import {
  addIndex,
  always,
  applySpec,
  either,
  filter,
  isEmpty,
  isNil,
  map,
  path,
  pipe,
  prop,
  propOr,
  when
} from 'ramda';

const mapIndexed = addIndex(map);

const GRANTEE_TYPE_LABEL_KEYS = {
  CHILD: 'BENEFICIAIRE_TYPE_CHILD_LABEL',
  SPOUSE: 'BENEFICIAIRE_TYPE_SPOUSE_LABEL'
};

const isNilOrEmpty = either(isNil, isEmpty);

const getGranteeTypeLabel = ({ type, getMiddleText }) => {
  const labelKey = propOr('', type, GRANTEE_TYPE_LABEL_KEYS);

  return isNilOrEmpty(labelKey) ? '' : getMiddleText(labelKey);
};

const getGranteeFallbackLabel = (index) => `Bénéficiaire n°${index + 1}`;

const getGranteeLabel = ({ grantee, index }) =>
  when(
    isNilOrEmpty,
    always(getGranteeFallbackLabel(index))
  )(propOr('', 'firstName', grantee));

const getDefaultGranteeErrorLabel = applySpec({
  label: getGranteeLabel,
  tag: ({ grantee, getMiddleText }) =>
    getGranteeTypeLabel({
      type: prop('type', grantee),
      getMiddleText
    })
});

const getGranteeTab = ({ tabs, granteeIndex }) =>
  path(['tabs', granteeIndex + 1], tabs) || null;

const toGranteeWithErrorContext = ({ granteesErrors }) => (grantee, index) => ({
  grantee,
  index,
  error: path([index], granteesErrors)
});

const hasError = ({ error }) => !isNilOrEmpty(error);

const toGranteeErrorLabel =
  ({ tabs, getMiddleText }) =>
    ({ grantee, index }) =>
      getGranteeTab({ tabs, granteeIndex: index }) ||
    getDefaultGranteeErrorLabel({
      grantee,
      index,
      getMiddleText
    });

export const getGranteesWithErrors = ({
  granteesValues = [],
  granteesErrors = [],
  getMiddleText,
  tabs
}) =>
  pipe(
    mapIndexed(toGranteeWithErrorContext({ granteesErrors })),
    filter(hasError),
    map(toGranteeErrorLabel({ tabs, getMiddleText }))
  )(granteesValues);
